<template>
  <v-container fluid>
    <template>
      <v-card :loading="loading">
        <v-card-title>
          <h2>
            <span v-if="loading">Carregando...</span>
            <template v-else>
              <span>Filtros</span>
            </template>
          </h2>
        </v-card-title>
        <form @submit.prevent="submitForm">
          <v-card-text>
            <v-select
              :items="tiposData"
              label="Data à considerar"
              v-model="tipoData"
            />
            <v-row>
              <v-col>
                <v-menu
                  v-model="menuDataInicio"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="dataInicioComp"
                      label="Data Início"
                      v-touch="dataInicio"
                      :error-messages="dataInicioErrors"
                      prepend-icon="mdi mdi-calendar"
                      readonly
                      v-on="on"
                      clearable
                    ></v-text-field>
                  </template>
                  <button-datepicker
                    v-model="dataInicio"
                    @input="menuDataInicio = false"
                  />
                </v-menu>
              </v-col>
              <v-col>
                <v-menu
                  v-model="menuDataFim"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="dataFimComp"
                      label="Data Fim"
                      v-touch="dataFim"
                      :error-messages="dataFimErrors"
                      prepend-icon="mdi mdi-calendar"
                      readonly
                      v-on="on"
                      clearable
                    ></v-text-field>
                  </template>
                  <button-datepicker
                    v-model="dataFim"
                    @input="menuDataFim = false"
                  />
                </v-menu>
              </v-col>
            </v-row>
            <v-select
              v-model="empresa"
              :items="empresas"
              item-text="nome_fantasia"
              item-value="id"
              label="Empresa"
              return-object
            />
            <v-autocomplete
              :items="clientes"
              label="Cliente"
              item-value="id"
              item-text="nome"
              placeholder="Digite para pesquisar"
              v-model="cliente"
              :search-input.sync="searchCliente"
              no-filter
              :loading="isLoadingCliente"
              hint="Deixe em branco para considerar todos os clientes"
              persistent-hint
              clearable
              return-object
            >
              <template v-slot:item="{ item }">
                <v-list-item-content>
                  <v-list-item-subtitle>
                    {{ documentoCliente(item) }} {{ item.nome }}
                  </v-list-item-subtitle>
                  <v-list-item-title>
                    {{ item.razao_social }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    Representante: {{ item.vendedor.nome }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </template>
              <template v-slot:selection="{ item }">
                <v-list-item-content>
                  <v-list-item-subtitle>
                    {{ documentoCliente(item) }} {{ item.nome }}
                  </v-list-item-subtitle>
                  <v-list-item-title>
                    {{ item.razao_social }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    Representante: {{ item.vendedor.nome }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-autocomplete>
            <v-autocomplete
              v-model="idVendedor"
              :items="vendedores"
              :search-input.sync="pesquisa"
              no-filter
              v-touch="idVendedor"
              :error-messages="vendedorErrors"
              :loading="pesquisando"
              item-text="nome"
              return-object
              label="Vendedores"
              clearable
              no-data-text="Nenhum vendedor encontrado"
              placeholder="Pesquise por nome ou número da matrícula (funcionários)"
              multiple
            />
            <v-select
              :items="situacoes"
              v-model="situacao"
              label="Situacao"
              item-text="text"
              item-value="value"
            />
          </v-card-text>
          <v-card-actions>
            <v-btn depressed color="primary" @click="submit" :loading="loading"
              >Gerar</v-btn
            >
          </v-card-actions>
        </form>
      </v-card>
    </template>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import _ from "lodash";
import { build } from "../lib/masks";
import moment from "moment";
import ButtonDatepicker from "../components/ButtonDatepicker";
import number_format from "../lib/number_format";

export default {
  mixins: [validationMixin],
  components: { ButtonDatepicker },

  validations: {
    dataInicio: { required },
    dataFim: { required },
    idVendedor: { required },
  },

  data() {
    return {
      dataInicio: moment().format("YYYY-MM-01"),
      dataFim: moment().format("YYYY-MM-DD"),
      menuDataInicio: false,
      menuDataFim: false,
      idVendedor: null,
      loading: false,
      pesquisando: false,
      pesquisa: null,
      tipoData: "data_vencimento",
      tiposData: [
        { text: "Data de vencimento", value: "data_vencimento" },
        { text: "Data de baixa", value: "data_baixa" },
      ],
      empresa: "",
      cliente: "",
      searchCliente: "",
      isLoadingCliente: false,
      clientes: [],
      situacoes: [
        {
          value: "",
          text: "Todas",
        },
        {
          value: "DG",
          text: "Digitação",
        },
        {
          value: "AB",
          text: "Aberto",
        },
        { value: "PG", text: "Pago" },
        {
          value: "CA",
          text: "Cancelado",
        },
      ],
      situacao: "",
    };
  },

  computed: {
    dataInicioComp: {
      get() {
        if (!this.dataInicio) return "";
        return this.dataInicio.split("-").reverse().join("/");
      },
      set(val) {
        this.dataInicio = val || "";
      },
    },
    dataFimComp: {
      get() {
        if (!this.dataFim) return "";
        return this.dataFim.split("-").reverse().join("/");
      },
      set(val) {
        this.dataFim = val || "";
      },
    },
    dataInicioErrors() {
      const errors = [];
      if (!this.$v.dataInicio.$dirty) return errors;
      !this.$v.dataInicio.required && errors.push(`Data Início é obrigatória`);
      return errors;
    },
    dataFimErrors() {
      const errors = [];
      if (!this.$v.dataFim.$dirty) return errors;
      !this.$v.dataFim.required && errors.push(`Data Fim é obrigatória`);
      return errors;
    },
    vendedorErrors() {
      const errors = [];
      if (!this.$v.idVendedor.$dirty) return errors;
      !this.$v.idVendedor.required && errors.push(`Vendedor é obrigatório`);
      return errors;
    },
    ...mapState({
      vendedores: (state) => state.vendedor.vendedores,
    }),
    empresas() {
      return [{ id: "", nome_fantasia: "Todas" }].concat(
        this.$store.state.empresa.empresas
      );
    },
  },

  methods: {
    documentoCliente(cliente) {
      if (cliente.tipo == "F") {
        return "CPF: " + build.cpf(cliente.cpf_cnpj);
      }
      return "CNPJ: " + build.cnpj(cliente.cpf_cnpj);
    },
    async submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        try {
          this.loading = true;
          const dados = await this.$store.dispatch(
            "relatorio/gerarDadosContasReceber1",
            {
              data_inicio: this.dataInicio,
              data_fim: this.dataFim,
              id_vendedor: this.idVendedor.map((v) => v.id).join(","),
              id_empresa: this.empresa ? this.empresa.id : 0,
              id_cliente: this.cliente ? this.cliente.id : 0,
              situacao: this.situacao,
              tipo_data: this.tipoData,
            }
          );

          dados.contas = dados.contas.map((conta) => {
            conta.data_vencimento = moment(
              conta.data_vencimento,
              "YYYY-MM-DD"
            ).format("DD/MM/YYYY");
            if (conta.data_baixa) {
              conta.data_baixa = moment(conta.data_baixa, "YYYY-MM-DD").format(
                "DD/MM/YYYY"
              );
            }

            conta.valor_receber = number_format(conta.valor_receber);
            conta.comissao_receber = number_format(conta.comissao_receber);
            conta.bv = number_format(conta.bv);

            switch (conta.situacao) {
              case "AB":
                conta.situacao = "Aberto";
                break;
              case "DG":
                conta.situacao = "Digitação";
                break;
              case "PG":
                conta.situacao = "Pago";
                break;
              case "CA":
                conta.situacao = "Cancelado";
                break;
            }

            return conta;
          });

          dados.total_valor_titulo = number_format(dados.total_valor_titulo);
          dados.total_valor_comissao = number_format(
            dados.total_valor_comissao
          );
          dados.total_valor_bv = number_format(dados.total_valor_bv);

          let nome_relatorio = "TÍTULOS";
          switch (this.situacao) {
            case "AB":
              nome_relatorio += " EM ABERTO";
              break;
            case "DG":
              nome_relatorio += " EM DIGITAÇÃO";
              break;
            case "PG":
              nome_relatorio += " PAGOS";
              break;
            case "CA":
              nome_relatorio += " CANCELADOS";
              break;
          }

          const rel = await this.$store.dispatch("relatorio/gerar", {
            template: "contas-receber.html",
            dados: {
              titulo: "RELATÓRIO DE MOVIMENTAÇÃO DE " + nome_relatorio,
              dados: {
                data_atual: moment().format("DD/MM/YYYY"),
                filters: {
                  data_inicio: this.dataInicioComp,
                  data_fim: this.dataFimComp,
                  nome_vendedor: this.idVendedor.map((v) => v.nome).join(", "),
                  tipo_data:
                    this.tipoData == "data_vencimento" ? "Vencimento" : "Baixa",
                  nome_cliente: this.cliente ? this.cliente.nome : "Todas",
                  nome_empresa: this.empresa
                    ? this.empresa.nome_fantasia
                    : "Todas",
                  nome_relatorio,
                },
                data: dados,
              },
            },
          });

          const url = window.URL.createObjectURL(
            new Blob([rel.data], { type: "application/pdf" })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("target", "_blank");
          document.body.appendChild(link);
          link.click();
          link.remove();

          this.loading = false;
        } catch (err) {
          this.loading = false;
        }
      }
    },
    pesquisarVendedores: _.debounce(async function () {
      this.pesquisando = true;
      await this.$store.dispatch("vendedor/listar", {
        pesquisa: this.pesquisa,
      });
      this.pesquisando = false;
    }, 300),
    async buscarClientes(val) {
      if (val.length >= 2) {
        if (this.isLoadingCliente) return;

        this.isLoadingCliente = true;

        try {
          var response = await this.$store.dispatch(
            "ordemMedicao/carregarClientes",
            { pesquisa: val, carregarVendedor: true, filtros: { ativo: true } }
          );
          this.clientes = response.clientes;

          this.isLoadingCliente = false;
        } catch (err) {
          this.isLoadingCliente = false;
        }
      } else {
        this.clientes = [];
      }
    },
  },
  async mounted() {
    this.$store.commit("ui/changeToolbar", {
      title: "Relatório de Movimentação de Títulos em Aberto",
    });

    this.$store.dispatch("empresa/listar");
  },
  watch: {
    pesquisa() {
      this.pesquisarVendedores();
    },
    searchCliente: _.debounce(function (val) {
      if (val) {
        this.buscarClientes(val);
      }
    }, 500),
  },
};
</script>
